/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Columns({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><rect width={5} height={11} x={1.5} y={2} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} rx={1} /><rect width={5} height={11} x={9.5} y={2} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} rx={1} /></svg>;
}
;